<template>
    <router-view :key="$route.fullPath" :listing="listing"></router-view>
</template>

<script>

export default {
    name: 'ListingParent',
    data() {
      return {
          listing: null
      }
    },
    mounted() {
        let vm = this;
        this.$http.get('/homes/'+this.$route.params.id).then(response => {

            vm.listing = response.data;

            this.$http.get('/switchListing/' + response.data.homeid).catch(() => {
                // eslint-disable-next-line
                console.log('Could not switch listing');
            });

            // axios.post('http://dev.circlepix.com:8081/aspen/listingSelect.htm', {selectListing: vm.listing.homeid})
        }).catch(() => {
            window.location.href = '/';
        });


    }

}
</script>

<style>

</style>
